import React from 'react';
import * as Icons from 'react-feather';
import {Link} from 'react-router-dom';

export default function Breadcrumb() {


    return (<>
        <div className="-intro-x breadcrumb breadcrumb--light ml-auto">
            <Link to="/dashboard">VFilms</Link>
            <Icons.ChevronLeft className="breadcrumb__icon"/>
            <span className="breadcrumb--active">داشبورد</span>
        </div>
    </>);
}
